var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4495_22949)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.26562,
    y: 5.09375,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.76562,
    y: 5.59375,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.2656,
    cy: 28.8441,
    rx: 5,
    ry: 2.08333,
    stroke: "#06513D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.2656,
    cy: 21.7607,
    rx: 2.5,
    ry: 2.5,
    stroke: "#06513D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8936 26.0156C20.9393 26.4826 20.2243 27.0989 19.8633 27.8008C19.7085 27.8458 19.5641 27.8927 19.4326 27.9453C19.1082 28.0751 18.8954 28.2108 18.7764 28.3232C18.7238 28.373 18.6991 28.4076 18.6885 28.4268C18.6988 28.4457 18.723 28.4808 18.7764 28.5312C18.8954 28.6437 19.1081 28.7794 19.4326 28.9092C19.4876 28.9312 19.5453 28.9509 19.6045 28.9717C19.6424 29.6092 19.9637 30.2052 20.499 30.7236C19.8966 30.6317 19.3444 30.4905 18.875 30.3027C18.446 30.1311 18.0487 29.9071 17.7461 29.6211C17.4799 29.3694 17.2489 29.0292 17.1953 28.6113L17.1836 28.4277L17.1953 28.2432C17.2489 27.8254 17.4799 27.4851 17.7461 27.2334C18.0486 26.9475 18.4461 26.7243 18.875 26.5527C19.6889 26.2272 20.7505 26.0365 21.8936 26.0156Z",
    fill: "#06513D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6367 26.0156C31.78 26.0365 32.8413 26.2272 33.6553 26.5527C34.0845 26.7244 34.4825 26.9472 34.7852 27.2334C35.0894 27.5212 35.3467 27.9249 35.3467 28.4277C35.3465 28.9303 35.0893 29.3334 34.7852 29.6211C34.4825 29.9073 34.0845 30.131 33.6553 30.3027C33.1858 30.4905 32.6336 30.6317 32.0312 30.7236C32.5666 30.2052 32.8878 29.6092 32.9258 28.9717C32.985 28.9509 33.0427 28.9312 33.0977 28.9092C33.4221 28.7794 33.6348 28.6437 33.7539 28.5312C33.8069 28.4812 33.8304 28.4458 33.8408 28.4268C33.8301 28.4075 33.806 28.3726 33.7539 28.3232C33.6348 28.2108 33.422 28.0751 33.0977 27.9453C32.9662 27.8927 32.8218 27.8458 32.667 27.8008C32.306 27.0989 31.591 26.4826 30.6367 26.0156Z",
    fill: "#06513D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4326 20.1768C31.767 20.1769 32.8485 21.2593 32.8486 22.5938C32.8485 23.9282 31.767 25.0096 30.4326 25.0098C29.9945 25.0097 29.5848 24.8913 29.2305 24.6875C29.5845 24.329 29.874 23.9069 30.0801 23.4395C30.1886 23.4847 30.3077 23.5097 30.4326 23.5098C30.9386 23.5096 31.3485 23.0998 31.3486 22.5938C31.3485 22.0877 30.9386 21.6769 30.4326 21.6768H30.4307C30.4204 21.1549 30.3141 20.6571 30.1289 20.1992C30.2285 20.1867 30.3296 20.1768 30.4326 20.1768Z",
    fill: "#06513D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1006 20.1768C22.2032 20.1768 22.3041 20.1858 22.4033 20.1982C22.2179 20.6563 22.1118 21.1547 22.1016 21.6768H22.1006C21.5944 21.6768 21.1838 22.0876 21.1836 22.5938C21.1838 23.0999 21.5944 23.5098 22.1006 23.5098C22.2256 23.5097 22.3446 23.4848 22.4531 23.4395C22.6592 23.9067 22.9479 24.3291 23.3018 24.6875C22.9477 24.8912 22.5384 25.0097 22.1006 25.0098C20.766 25.0098 19.6838 23.9283 19.6836 22.5938C19.6838 21.2592 20.766 20.1768 22.1006 20.1768Z",
    fill: "#06513D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4495_22949",
    x: 0.0656252,
    y: 0.89375,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4495_22949"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4495_22949",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct11);
export default __webpack_public_path__ + "static/media/product11.62570326ef3587bb70f5e88f41f8e0ae.svg";
export { ForwardRef as ReactComponent };